{
	"ariaCreateNewAIStyle": "Create New AI Style",
	"createAiStyle": "Create AI Style"
}
